// removed by extract-text-webpack-plugin
module.exports = {"container":"UserInfoRow__container___1154L"};